import { Decoration_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const anchorConverter = {
  fromPm: {
    type: Decoration_Type.ANCHOR,
    convert: (mark) => {
      const { attrs } = mark;
      return [
        {
          type: Decoration_Type.ANCHOR,
          anchorData: { ...attrs }
        }
      ];
    }
  },
  toPm: {
    type: Decoration_Type.ANCHOR,
    convert: (decoration) => {
      const { anchorData } = decoration;
      return {
        type: Decoration_Type.ANCHOR,
        attrs: { ...anchorData }
      };
    }
  }
};
export {
  anchorConverter
};
//# sourceMappingURL=anchor-converter.js.map
